import React from 'react'
import { motion } from 'framer-motion'
import { X } from 'lucide-react'

export default function Privacy({ onClose }) {
  const fade = {
    hidden: { opacity: 0, y: 50 },
    visible: i => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, delay: i * 0.05 }
    })
  }

  const topics = [
    {
      h: '1. บทนำ',
      p: [
        'Kuizy.ai เคารพความเป็นส่วนตัวของผู้ใช้ และดำเนินการตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (PDPA) และระเบียบสากล เช่น GDPR (EU), CCPA (รัฐแคลิฟอร์เนีย), COPPA (สหรัฐฯ) และ UK-GDPR',
      ],
    },
    {
      h: '2. ผู้ควบคุมข้อมูล (Data Controller)',
      p: [
        'บริษัท ควิซซี่ เอไอ จำกัด เลขทะเบียน 0-1234-56789-00',
        'ที่อยู่: 123 ถ.วิทยุ แขวงลุมพินี เขตปทุมวัน กรุงเทพฯ 10330',
        'อีเมล DPO: dpo@kuizy.ai  ·  โทร: +66 2-123-4567',
      ],
    },
    {
      h: '3. ประเภทข้อมูลส่วนบุคคลที่เก็บ',
      p: [
        'ข้อมูลระบุตัวบุคคล: ชื่อ, อีเมล, เบอร์โทร, ตำแหน่งงาน',
        'ข้อมูลบัญชี: Username, Password (bcrypt-hash), Subscription Plan, ประวัติการชำระเงิน (Token)',
        'ข้อมูลอุปกรณ์/การใช้งาน: IP, User-Agent, Device ID, Cookie ID, Log Event, Crash Report',
        'ข้อมูลเนื้อหา: ชุดข้อสอบ, คำตอบผู้สอบ, คะแนน, ไฟล์แนบ',
        'ข้อมูลสถานศึกษา/องค์กร (ถ้ามี): ชื่อสถาบัน, ห้องเรียน, รายวิชา',
      ],
    },
    {
      h: '4. แหล่งข้อมูล',
      p: [
        'ข้อมูลที่ผู้ใช้ให้โดยตรงผ่านแบบฟอร์มหรือ API',
        'ข้อมูลที่สร้างอัตโนมัติเมื่อใช้บริการ (Server Log, Analytics)',
        'ข้อมูลจากบุคคลที่สาม เช่น Google OAuth, LMS Integration (ด้วยความยินยอม)',
      ],
    },
    {
      h: '5. วัตถุประสงค์และฐานกฎหมาย',
      p: [
        'สัญญา: เปิดบัญชี, ประมวลผลข้อสอบ, ส่งผลสอบ',
        'ประโยชน์ชอบธรรม: ป้องกันทุจริต Logging, ปรับปรุง UX',
        'ความยินยอม: ส่งอีเมลข่าวสาร การตลาด, Cookie Analytics/AdTech',
        'ข้อบังคับกฎหมาย: บัญชี/ภาษี, การร้องขอของศาลหรือหน่วยงานรัฐ',
      ],
    },
    {
      h: '6. การใช้คุกกี้และเทคโนโลยีติดตาม',
      p: [
        'ใช้ Strictly Necessary Cookies (Auth, Preference) เป็นพื้นฐาน',
        'Analytics Cookies (GA4 – เปิด IP Anonymization) และ Marketing Cookie จะถูกใช้งานก็ต่อเมื่อผู้ใช้กด “ยอมรับ” ในแบนเนอร์คุกกี้',
        'สามารถจัดการคุกกี้ได้ใน Browser หรือเมนู “การตั้งค่าความเป็นส่วนตัว”',
      ],
    },
    {
      h: '7. การแบ่งปันและผู้ประมวลผลย่อย',
      p: [
        'เราแบ่งปันข้อมูลกับ Sub-Processors ที่ผ่านการประเมินด้านความปลอดภัยและทำสัญญา DPA เช่น AWS (สิงคโปร์/แฟรงก์เฟิร์ต), Cloudflare, Stripe, SendGrid.',
        'เมื่อจำเป็นตามหมายศาล หรือคำสั่งหน่วยงานรัฐที่ชอบด้วยกฎหมาย',
      ],
    },
    {
      h: '8. การโอนข้อมูลข้ามพรมแดน',
      p: [
        'ข้อมูลอาจถูกโอนไปยังประเทศที่ไม่มีกฎหมายคุ้มครองข้อมูลเทียบเท่า GDPR โดยใช้กลไก Standard Contractual Clauses (SCCs) รุ่น 2021/914 และมาตรการเสริม (Encryption, Access Control)',
      ],
    },
    {
      h: '9. ระยะเวลาการเก็บและการลบ',
      p: [
        'เก็บข้อมูลตราบใดที่จำเป็นต่อวัตถุประสงค์หรือข้อกำหนดทางกฎหมาย (เช่น ภาษีไม่เกิน 10 ปี)',
        'ข้อมูลจะถูกลบหรือทำให้ไม่ระบุตัวตนภายใน 90 วันหลังยกเลิกบัญชี หรือภายใน 30 วันนับจากคำร้องขอลบภายใต้ GDPR/PDPA (ยกเว้นข้อมูลที่กฎหมายบังคับเก็บ)',
      ],
    },
    {
      h: '10. ความปลอดภัยของข้อมูล',
      p: [
        'Encryption at Rest (AES-256), Encryption in Transit (TLS 1.3)',
        'Role-based Access Control, Zero-Trust Architecture, MFA สําหรับผู้ดูแลระบบ',
        'Third-party Penetration Test ปีละ 2 ครั้ง, Bug Bounty Program, การสำรองข้อมูลรายวัน',
      ],
    },
    {
      h: '11. สิทธิของเจ้าของข้อมูล',
      p: [
        'เข้าถึง, แก้ไข, ลบ, พกพาข้อมูล, คัดค้าน, จำกัดการประมวลผล, ถอนความยินยอม',
        'ยื่นคำร้องได้ทาง dpo@kuizy.ai บริษัทจะตอบกลับภายใน 30 วัน (อาจขยายได้อีก 30 วันหากซับซ้อน)',
        'สิทธิร้องเรียนต่อ สคส. (PDPA) หรือ Supervisory Authority (GDPR) หากเชื่อว่าบริษัทละเมิดกฎหมาย',
      ],
    },
    {
      h: '12. เด็กและบัญชีสถานศึกษา',
      p: [
        'บริการไม่ได้ออกแบบมาสำหรับเด็กต่ำกว่า 13 ปี หากใช้บริการในสถานศึกษา ผู้สอนต้องได้รับความยินยอมจากผู้ปกครองตาม COPPA/PDPA ก่อนเก็บข้อมูลเด็ก',
      ],
    },
    {
      h: '13. การเปลี่ยนแปลงนโยบาย',
      p: [
        'เราจะประกาศการแก้ไขอย่างชัดเจนบนเว็บไซต์ และจะมีผลหลังประกาศ 7 วัน หากมีการเปลี่ยนสาระสำคัญ',
      ],
    },
    {
      h: '14. ติดต่อ DPO',
      p: [
        'Data Protection Officer: คุณเจนวิทย์  อีเมล dpo@kuizy.ai  โทร +66 80-808-6001-5',
        'ที่อยู่: 21 ซอยประเสริฐมนูกิจ 29 แยก 7 ถนนประเสริฐมนูกิจ แขวงจรเข้บัว เขตลาดพร้าว กรุงเทพฯ 10230',
      ],
    },
  ]

  return (
    <section className="relative">
      <button
        onClick={onClose}
        className="fixed top-4 right-4 bg-white/80 backdrop-blur p-3 rounded-full shadow hover:bg-white z-[60]"
      >
        <X size={30} />
      </button>

      <div className="pt-20 pb-10 px-6 max-w-5xl mx-auto space-y-12">
        <motion.h1
          className="text-4xl md:text-5xl font-extrabold text-primary text-center"
          variants={fade}
          custom={0}
          initial="hidden"
          animate="visible"
        >
          นโยบายความเป็นส่วนตัว
        </motion.h1>

        {topics.map((t, idx) => (
          <motion.div key={t.h} variants={fade} custom={idx + 1} initial="hidden" animate="visible">
            <h2 className="text-xl md:text-2xl font-bold text-secondary mb-3">{t.h}</h2>
            {t.p.map((line, i) => (
              <p key={i} className="text-base md:text-lg leading-relaxed text-gray-700 mb-2">{line}</p>
            ))}
          </motion.div>
        ))}
      </div>
    </section>
  )
}
